export function resetFavicon(): void {
  const head = document.head || document.getElementsByTagName('head')[0];

  // Find the existing favicon link element
  const link = head.querySelector('link[rel="shortcut icon"]') || head.querySelector('link[rel="icon"]');

  // If a custom favicon link element exists, remove it
  if (link) {
    head.removeChild(link);
  }

  // Add the default favicon back
  const defaultLink = document.createElement('link');
  defaultLink.rel = 'shortcut icon';
  defaultLink.type = 'image/x-icon';
  defaultLink.href = './../../assets/favicon.ico';
  head.appendChild(defaultLink);
}
